"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleItemOpen = function (index) {
            var item = _this.props.value[index];
            var newValue = _this.props.value.slice();
            newValue.splice(index, 1, __assign({}, item, { open: !item.open }));
            _this.props.onChange(newValue);
        };
        _this.selectItem = function (index) {
            _this.toggleItemOpen(index);
            var openedItemIndex = _this.props.value.findIndex(function (item) { return item.open; });
            if (openedItemIndex === index)
                return;
            if (openedItemIndex !== -1) {
                setImmediate(function () { return _this.toggleItemOpen(openedItemIndex); });
            }
        };
        return _this;
    }
    Accordion.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, style = _a.style, type = _a.type, value = _a.value, multiSelect = _a.multiSelect;
        return (React.createElement("ul", { className: classnames_1.default(styles.accordion, styles[type], className), style: style }, value.map(function (item, index) { return (React.createElement(AccordionMenuItem, __assign({ key: index }, item, { onClick: function () {
                if (multiSelect) {
                    _this.toggleItemOpen(index);
                }
                else {
                    _this.selectItem(index);
                }
                item.onClick && item.onClick();
            } }))); })));
    };
    return Accordion;
}(React.Component));
exports.default = Accordion;
var AccordionMenuItem = /** @class */ (function (_super) {
    __extends(AccordionMenuItem, _super);
    function AccordionMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { targetHeight: 0 };
        _this.container = React.createRef();
        _this.contents = React.createRef();
        _this.onTransitionEnd = function (e) {
            e.stopPropagation();
            _this.setState({ targetHeight: 0 });
        };
        return _this;
    }
    AccordionMenuItem.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        if (prevProps.open === this.props.open)
            return 0;
        var container = this.container.current;
        var contents = this.contents.current;
        if (!this.props.open) {
            container.style.height = contents.offsetHeight + 'px';
            container.offsetHeight;
            container.style.height = null;
            return 0;
        }
        return contents.offsetHeight;
    };
    AccordionMenuItem.prototype.componentDidUpdate = function (prevProps, _prevState, snapshot) {
        if (prevProps.open === this.props.open)
            return;
        this.setState({ targetHeight: snapshot });
    };
    AccordionMenuItem.prototype.render = function () {
        var _a;
        var targetHeight = this.state.targetHeight;
        var _b = this.props, title = _b.title, contents = _b.contents, open = _b.open, onClick = _b.onClick;
        return (React.createElement("li", { className: classnames_1.default(styles.item, (_a = {}, _a[styles.open] = open, _a)) },
            React.createElement("div", { className: styles.title, onClick: onClick },
                title,
                " ",
                React.createElement(icons_1.DropdownIcon, { className: styles.icon })),
            React.createElement("div", { style: open && targetHeight ? { height: targetHeight } : void 0, className: styles.container, ref: this.container, onTransitionEnd: this.onTransitionEnd },
                React.createElement("div", { className: styles.contents, ref: this.contents }, contents))));
    };
    return AccordionMenuItem;
}(React.Component));
